<div class="client-padding">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 align-self-center">
                <div class="iq-client iq-client-style-1 iq-has-grascale">
                    <app-client [Images]="Images"></app-client>
                </div>
            </div>
        </div>
    </div>
</div>